export default (key) => ({
    init () {
        this.$refs.submit.disabled = true;
        this.$watch('recaptchaLoaded', (value) => {
            if (value) {
                grecaptcha.render(this.$refs.recaptcha, {
                    sitekey: key,
                    callback: () => {
                        this.$refs.submit.disabled = false;
                    },
                });
            }
        });
    },
    get recaptchaLoaded () {
        return Alpine.store('recaptcha:loaded');
    },
});
